import { render, staticRenderFns } from "./PlatformOwnOfferComponent.vue?vue&type=template&id=f0eb3ca4&"
import script from "./PlatformOwnOfferComponent.vue?vue&type=script&lang=js&"
export * from "./PlatformOwnOfferComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports